module.exports = __webpack_public_path__ + "img/left_2_hover.ed2322e6.png";